export const classes = {
  row: 'whitespace-pre',
  clickable: 'cursor-pointer',
};

export const styles = {
  tableRow: { '&:last-child td, &:last-child th': { border: 0 } },
};
